import { useEffect, useState } from 'react';
import { directusAPI } from '../../../api';

/**
 * Reference data for the wizard: the user's projects and the published article
 * structures available to the user's workspace.
 */
export function useWizardReferenceData() {
  const [availableStructures, setAvailableStructures] = useState([]);
  const [, setIsLoadingStructures] = useState(false);
  const [, setProjects] = useState([]);
  const [, setIsLoadingProjects] = useState(false);

  useEffect(() => {
    const fetchProjects = async () => {
      setIsLoadingProjects(true);
      try {
        const userId = localStorage.getItem('user_id');
        const response = await directusAPI.get('/items/projects', {
          params: {
            filter: { owner: userId }
          }
        });
        setProjects(response.data.data);
      } catch (error) {
      } finally {
        setIsLoadingProjects(false);
      }
    };

    fetchProjects();
  }, []);

  // Fetch available article structures from Directus.
  // Default selection stays empty ("Domyślna struktura") unless the user picks one
  // or an existing article already has a linked structure.
  useEffect(() => {
    const fetchStructures = async () => {
      setIsLoadingStructures(true);
      try {
        const userId = localStorage.getItem('user_id');
        let linkedWorkspaceId = null;

        if (userId) {
          try {
            const userResponse = await directusAPI.get(`/users/${userId}`, {
              params: { fields: ['linked_workspace.id', 'linked_workspace'] }
            });
            linkedWorkspaceId =
              userResponse?.data?.data?.linked_workspace?.id ||
              userResponse?.data?.data?.linked_workspace ||
              null;
          } catch (_workspaceError) {
            linkedWorkspaceId = null;
          }
        }

        const publishedFilter = { status: { _eq: 'published' } };
        const workspaceFilter = linkedWorkspaceId
          ? {
              _or: [
                { linked_workspace: { _eq: Number(linkedWorkspaceId) } },
                { linked_workspace: { _null: true } }
              ]
            }
          : { linked_workspace: { _null: true } };

        const response = await directusAPI.get('/items/articles_structures', {
          params: {
            filter: {
              _and: [publishedFilter, workspaceFilter]
            },
            sort: 'sort,title',
            fields: 'id,title,article_structure_body,linked_workspace'
          }
        });
        const structures = response.data.data || [];
        console.log('📚 Fetched article structures:', structures);
        setAvailableStructures(structures);
      } catch (error) {
        console.error('❌ Failed to fetch article structures:', error);
      } finally {
        setIsLoadingStructures(false);
      }
    };

    fetchStructures();
  }, []);

  return { availableStructures };
}
